const BaseMapIcon = () =>
{
      return (
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.9892 20.5887L5.005 14.3812L3.25 15.7462L13 23.3296L22.75 15.7462L20.9842 14.3704L12.9892 20.5887ZM13 17.8371L20.9733 11.6296L22.75 10.2537L13 2.67041L3.25 10.2537L5.01583 11.6296L13 17.8371ZM13 5.41124L19.2183 10.2537L13 15.0962L6.78167 10.2537L13 5.41124Z" fill="#E1EFFA" />
            </svg>

      )
}

export default BaseMapIcon